<template>
  <TimeslotDashboardLayout>
    <!--    <template v-slot:mobile-navbar>-->
    <!--      <div-->
    <!--        data-collapse="medium"-->
    <!--        data-animation="over-left"-->
    <!--        data-duration="400"-->
    <!--        data-w-id="df38f32a-3fbb-f2fb-24e9-fdc828eab25c"-->
    <!--        data-easing="ease"-->
    <!--        data-easing2="ease"-->
    <!--        role="banner"-->
    <!--        class="navbar-mobile w-nav"-->
    <!--      >-->
    <!--        <div class="navbar1_container">-->
    <!--          <router-link-->
    <!--            to="/professional-dashboard"-->
    <!--            class="navbar1_logo-link w-nav-brand"-->
    <!--          >-->
    <!--            <img-->
    <!--              src="@/assets/timeslot-images/timeslate-logo.svg"-->
    <!--              loading="lazy"-->
    <!--              alt=""-->
    <!--              class="navbar1_logo"-->
    <!--          /></router-link>-->

    <!--          <div-->
    <!--            @click="showNav"-->
    <!--            class="navbar1_menu-button w-nav-button"-->
    <!--            style="-webkit-user-select: text;"-->
    <!--            aria-label="menu"-->
    <!--            role="button"-->
    <!--            tabindex="0"-->
    <!--            aria-controls="w-nav-overlay-0"-->
    <!--            aria-haspopup="menu"-->
    <!--            aria-expanded="false"-->
    <!--          >-->
    <!--            <div class="menu-icon1">-->
    <!--              <div class="menu-icon1_line-top"></div>-->
    <!--              <div class="menu-icon1_line-middle">-->
    <!--                <div class="menu-icon_line-middle-inner"></div>-->
    <!--              </div>-->
    <!--              <div class="menu-icon1_line-bottom"></div>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--        <div-->
    <!--          v-if="cross"-->
    <!--          class="w-nav-overlay"-->
    <!--          data-wf-ignore=""-->
    <!--          id="w-nav-overlay-0"-->
    <!--          style="height: 100vh; display: block; width: 100%;"-->
    <!--        >-->
    <!--          <nav-->
    <!--            role="navigation"-->
    <!--            class="navbar1_menu w-nav-menu"-->
    <!--            style="transform: translateX(0px) translateY(0px);  height: 100vh; transition: transform 400ms ease 0s;"-->
    <!--            data-nav-menu-open=""-->
    <!--          >-->
    <!--            <div class="div-block-4-copy top">-->
    <!--              <div-->
    <!--                data-w-id="df38f32a-3fbb-f2fb-24e9-fdc828eab262"-->
    <!--                class="link-block-3 w-inline-block"-->
    <!--                @click="closeNav"-->
    <!--              >-->
    <!--                <img-->
    <!--                  src="@/assets/timeslot-images/cancel.svg"-->
    <!--                  loading="lazy"-->
    <!--                  alt=""-->
    <!--                />-->
    <!--              </div>-->
    <!--              <div class="div-block-51">-->
    <!--                <div class="div-block-5-copy">-->
    <!--                  <div class="div-block-6-copy">-->
    <!--                    <img-->
    <!--                      v-if="'customerDisplayPicture' in customerInfo"-->
    <!--                      class="image-profile-pic"-->
    <!--                      :src="customerInfo.customerDisplayPicture"-->
    <!--                    />-->
    <!--                    <div class="text-block-8" v-else>-->
    <!--                      {{ userInfo.customerFirstName.charAt(0)-->
    <!--                      }}{{ userInfo.customerLastName.charAt(0) }}-->
    <!--                    </div>-->
    <!--                  </div>-->
    <!--                  <div class="div-block-28">-->
    <!--                    <div class="text-block-6">-->
    <!--                      {{ userInfo.customerFirstName }}-->
    <!--                      {{ userInfo.customerLastName }}-->
    <!--                    </div>-->
    <!--                    <div class="text-block-7">-->
    <!--                      <a @click="goToProfile" class="link-18">View profile</a>-->
    <!--                    </div>-->
    <!--                  </div>-->
    <!--                </div>-->
    <!--                <div class="div-block-29">-->
    <!--                  <router-link-->
    <!--                    to="/professional-dashboard"-->
    <!--                    aria-current="page"-->
    <!--                    class="link-block-4 dashboard w-inline-block w&#45;&#45;current"-->
    <!--                  >-->
    <!--                    <div class="text-block-27">Dashboard</div>-->
    <!--                  </router-link>-->
    <!--                  <router-link-->
    <!--                    to="/professional-messages"-->
    <!--                    class="link-block-4 message w-inline-block"-->
    <!--                  >-->
    <!--                    <div class="text-block-27">Messages</div>-->
    <!--                  </router-link>-->
    <!--                  <router-link-->
    <!--                    to="/professional-bookings"-->
    <!--                    class="link-block-4 booking w-inline-block"-->
    <!--                  >-->
    <!--                    <div class="text-block-27">Bookings</div>-->
    <!--                  </router-link>-->

    <!--                  <router-link-->
    <!--                    to="/professional-classes"-->
    <!--                    class="link-block-4 classes w-inline-block"-->
    <!--                  >-->
    <!--                    <div class="text-block-27">My Classes</div>-->
    <!--                  </router-link>-->

    <!--                  <router-link-->
    <!--                    to="/professional-subscriptions"-->
    <!--                    class="link-block-4 feeds w-inline-block"-->
    <!--                  >-->
    <!--                    <div class="text-block-27">Subscriptions</div>-->
    <!--                  </router-link>-->
    <!--                  <router-link-->
    <!--                    to="/professional-availability"-->
    <!--                    class="link-block-4 availability w-inline-block"-->
    <!--                  >-->
    <!--                    <div class="text-block-27">Available slots</div>-->
    <!--                  </router-link>-->
    <!--                  <router-link-->
    <!--                    to="/professional-wallet"-->
    <!--                    class="link-block-4 wallet w-inline-block"-->
    <!--                  >-->
    <!--                    <div class="text-block-27">Wallet</div>-->
    <!--                  </router-link>-->
    <!--                  <router-link-->
    <!--                    to="/professional-settings"-->
    <!--                    class="link-block-4 settings w-inline-block"-->
    <!--                  >-->
    <!--                    <div class="text-block-27">Settings</div>-->
    <!--                  </router-link>-->
    <!--                  <router-link-->
    <!--                    to="/professional-notifications"-->
    <!--                    class="link-block-4 discover w-inline-block"-->
    <!--                  >-->
    <!--                    <div class="text-block-27">Notifications</div>-->
    <!--                  </router-link>-->
    <!--                </div>-->
    <!--                <div class="div-block-29-copy">-->
    <!--                  <router-link-->
    <!--                    to="/discover-professionals"-->
    <!--                    class="link-block-4 conection w-inline-block"-->
    <!--                  >-->
    <!--                    <div class="text-block-27">Discover</div>-->
    <!--                  </router-link>-->
    <!--                  <router-link-->
    <!--                    to="/professional-support"-->
    <!--                    class="link-block-4 support w-inline-block"-->
    <!--                  >-->
    <!--                    <div class="text-block-27">Support</div>-->
    <!--                  </router-link>-->
    <!--                  <a-->
    <!--                    @click="logout"-->
    <!--                    class="link-block-4 log-out w-inline-block"-->
    <!--                  >-->
    <!--                    <div class="text-block-27">Log out</div>-->
    <!--                  </a>-->
    <!--                </div>-->
    <!--              </div>-->
    <!--            </div>-->
    <!--            <div></div>-->
    <!--          </nav>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </template>-->
    <!--    <template v-slot:app-navbar>-->
    <!--      <ProfessionalAppNavBar />-->
    <!--    </template>-->
    <!--    <template v-slot:sidebar>-->
    <!--      <ProfessionalSidebar />-->
    <!--    </template>-->
    <div class="main-content settings">
      <div>
        <div class="content-div">
          <div class="tap-heading-div">
            <h1 class="tab-heading">Settings</h1>
            <div class="tab-text"></div>
            <div class="no-update_wrapper" style="display: none;">
              <div class="no-update_content">
                <img
                  src="https://uploads-ssl.webflow.com/629917a86b347b2be85e67ff/629917a86b347be87e5e6851_timer.svg"
                  loading="lazy"
                  alt=""
                />
                <div class="no-update-yet">Nothing to show here</div>
                <div class="appointments">
                  Appointments with professionals would show up here
                </div>
                <router-link
                  to="/discover"
                  class="explore-professionals_button w-button"
                  >Explore professionals</router-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        data-current="Tab 1"
        data-easing="ease"
        data-duration-in="300"
        data-duration-out="100"
        class="tabs w-tabs"
      >
        <div class="tabs-menu-2 w-tab-menu">
          <a
            data-w-tab="Tab 1"
            @click="openPersonal"
            :class="
              personal
                ? 'booking-tab w-inline-block w-tab-link w--current'
                : 'booking-tab w-inline-block w-tab-link'
            "
          >
            <div>Personal Info</div>
          </a>
          <a
            data-w-tab="Tab 2"
            @click="openProfessional"
            :class="
              professional
                ? 'booking-tab w-inline-block w-tab-link w--current'
                : 'booking-tab w-inline-block w-tab-link'
            "
          >
            <div>Professional Info</div>
          </a>
          <a
            data-w-tab="Tab 4"
            @click="openPayment"
            :class="
              payment
                ? 'booking-tab w-inline-block w-tab-link w--current'
                : 'booking-tab w-inline-block w-tab-link'
            "
          >
            <div>Account Info</div>
          </a>
          <a
            data-w-tab="Tab 3"
            @click="openSecurity"
            :class="
              security
                ? 'booking-tab w-inline-block w-tab-link w--current'
                : 'booking-tab w-inline-block w-tab-link'
            "
          >
            <div>Reset Password</div>
          </a>
        </div>
        <div class="w-tab-content">
          <div
            data-w-tab="Tab 1"
            :class="personal ? 'w-tab-pane w--tab-active' : 'w-tab-pane'"
          >
            <div class="personal-info">
              <div class="payment-info-wrapper">
                <div class="profile-picture-wrapper">
                  <div class="div-block-96">
                    <input
                      type="file"
                      @change="onImageSelect"
                      accept="image/x-png,image/jpeg"
                      id="upload-profile"
                    />
                    <img
                      loading="lazy"
                      alt=""
                      class="profile-picture-timeslot"
                      :src="
                        updateModel.customerDisplayPicture ||
                          customerInfo.customerDisplayPicture ||
                          require('@/assets/timeslot-images/Profile-pics.svg')
                      "
                    />
                    <a
                      href="#"
                      class="link-block-8 w-inline-block"
                      @click="uploadProfile"
                    ></a>
                  </div>
                  <div>
                    <div>
                      <BaseComponentLoader
                        v-if="
                          loader.nonBlockingLoader &&
                            !name &&
                            !about &&
                            !country &&
                            !timezone &&
                            !phone &&
                            !interest
                        "
                        loaderAlignment="center"
                      />
                      <div v-else class="link-15" @click="uploadImageProfile">
                        Upload profile picture
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="first-name-wrapper">
                <div class="title-wrapper">
                  <div class="text-block-73">Name</div>
                  <div class="div-block-97">
                    <div>
                      <div
                        data-w-id="f8439559-0469-b343-0ce1-6b417602d5c1"
                        class="cancel-btn"
                        @click="toggleName"
                        v-if="name"
                      >
                        Cancel
                      </div>
                    </div>
                    <div>
                      <div
                        data-w-id="f8439559-0469-b343-0ce1-6b417602d5c4"
                        class="edit-btn"
                        @click="toggleName"
                        v-if="!name"
                      >
                        Edit
                      </div>
                    </div>
                  </div>
                </div>
                <div class="saved-name-wrapper" v-if="!name">
                  <div class="text-block-74">
                    {{ customerInfo.customerName }}
                  </div>
                </div>
                <div class="edit-name" v-if="name">
                  <div class="text-block-75">Full Name</div>
                  <input
                    type="text"
                    class="text-field settings w-input"
                    maxlength="256"
                    name="field-5"
                    data-name="Field 5"
                    placeholder="Enter name"
                    id="field-5"
                    required=""
                    v-model="updateCusModel.customerName"
                  />
                  <BaseComponentLoader
                    v-if="
                      loader.nonBlockingLoader &&
                        !about &&
                        !interest &&
                        !country &&
                        !timezone &&
                        !phone &&
                        pictureLoad
                    "
                    loaderAlignment="left"
                  />
                  <div
                    v-else
                    data-w-id="f8439559-0469-b343-0ce1-6b417602d5cd"
                    class="button-18 w-button"
                    @click="closeName"
                  >
                    Update
                  </div>
                </div>
              </div>
              <div class="about-wrapper">
                <div class="title-wrapper">
                  <div class="text-block-73">
                    Summary
                    <div class="tooltip-mine">
                      <img
                        width="14"
                        height="14"
                        src="@/assets/timeslot-images/info.svg"
                      />
                      <span class="tooltiptext-mine"
                        >This is your professional summary</span
                      >
                    </div>
                  </div>
                  <div class="div-block-97">
                    <div>
                      <div class="cancel-btn" @click="toggleAbout" v-if="about">
                        Cancel
                      </div>
                    </div>
                    <div>
                      <div
                        data-w-id="31679b58-e423-a2b4-2900-5d5b8cfcae31"
                        @click="toggleAbout"
                        class="edit-btn"
                        v-if="!about"
                      >
                        Edit
                      </div>
                    </div>
                  </div>
                </div>
                <div class="saved-description" v-if="!about">
                  <div class="text-block-74">
                    {{ professionalInfo.professionalSummary }}
                  </div>
                </div>
                <div class="edit-description" v-if="about">
                  <div class="text-block-75">Summary</div>
                  <textarea
                    id="field-3"
                    name="field-3"
                    @input="getWordCount"
                    maxlength="5000"
                    data-name="field"
                    placeholder="Add a description"
                    class="text-field rich-text w-input"
                    v-model="updateModel.professionalSummary"
                  ></textarea>
                  <div
                    v-if="showMaxWordCountError"
                    style="display:flex; justify-content: flex-start; color:red;"
                  >
                    Summary must not exceed 150 characters
                  </div>
                  <div
                    v-if="!showMaxWordCountError"
                    style="display:flex; justify-content: flex-end;"
                  >
                    {{ getWordCount() }}/150
                  </div>

                  <BaseComponentLoader
                    v-if="
                      loader.nonBlockingLoader &&
                        !name &&
                        !interest &&
                        !country &&
                        !timezone &&
                        !phone
                    "
                    loaderAlignment="left"
                  />

                  <div v-else class="button-18 w-button" @click="closeAbout">
                    Update
                  </div>
                </div>
              </div>
              <div class="country-wrapper">
                <div class="title-wrapper">
                  <div class="text-block-73">Country</div>
                  <div class="div-block-97">
                    <div>
                      <div
                        class="cancel-btn"
                        @click="toggleCountry"
                        v-if="country"
                      >
                        Cancel
                      </div>
                    </div>
                    <div>
                      <div
                        class="edit-btn"
                        @click="toggleCountry"
                        v-if="!country"
                      >
                        Edit
                      </div>
                    </div>
                  </div>
                </div>
                <div class="saved-country" v-if="!country">
                  <div class="text-block-74">
                    {{ customerInfo.customerCountry }}
                  </div>
                </div>
                <div class="edit-country" v-if="country">
                  <div class="text-block-75">Select country</div>
                  <div class="booking-fee-holder">
                    <FormulateInput
                      type="select"
                      validation="required"
                      name="country"
                      validation-name="Country"
                      placeholder="Country"
                      :options="countries"
                      v-model="updateCusModel.customerCountry"
                    />
                  </div>
                  <BaseComponentLoader
                    v-if="
                      loader.nonBlockingLoader &&
                        !about &&
                        !interest &&
                        !name &&
                        !timezone &&
                        !phone
                    "
                    loaderAlignment="left"
                  />
                  <div v-else class="button-18 w-button" @click="closeCountry">
                    Update
                  </div>
                </div>
              </div>
              <div class="timezone-wrappers">
                <div class="title-wrapper">
                  <div class="text-block-73">Timezone</div>
                  <div class="div-block-97">
                    <div>
                      <div
                        class="cancel-btn"
                        @click="toggleTimezone"
                        v-if="timezone"
                      >
                        Cancel
                      </div>
                    </div>
                    <div>
                      <div
                        class="edit-btn"
                        @click="toggleTimezone"
                        v-if="!timezone"
                      >
                        Edit
                      </div>
                    </div>
                  </div>
                </div>
                <div class="saved-timezone" v-if="!timezone">
                  <div class="text-block-74">
                    {{ customerInfo.customerTimezone }}
                  </div>
                </div>
                <div class="saved-timezones" v-if="timezone">
                  <div class="text-block-75">Select timezone</div>
                  <div class="booking-fee-holder-2">
                    <FormulateInput
                      type="select"
                      validation="required"
                      name="timezone"
                      validation-name="Timezone"
                      placeholder="Select your timezone"
                      :options="timezones"
                      v-model="updateCusModel.customerTimezone"
                    />
                  </div>

                  <BaseComponentLoader
                    v-if="
                      loader.nonBlockingLoader &&
                        !about &&
                        !interest &&
                        !country &&
                        !name &&
                        !phone
                    "
                    loaderAlignment="left"
                  />

                  <div v-else class="button-18 w-button" @click="closeTimezone">
                    Update
                  </div>
                </div>
              </div>
              <div class="phone-number-wrapper">
                <div class="title-wrapper">
                  <div class="text-block-73">Phone number</div>
                  <div class="div-block-97">
                    <div>
                      <div class="cancel-btn" @click="togglePhone" v-if="phone">
                        Cancel
                      </div>
                    </div>
                    <div>
                      <div
                        data-w-id="58429a83-496c-7aa6-635b-a566e162047f"
                        class="edit-btn"
                        @click="togglePhone"
                        v-if="!phone"
                      >
                        Edit
                      </div>
                    </div>
                  </div>
                </div>
                <div class="saved-name-wrapper" v-if="!phone">
                  <div class="text-block-74">
                    {{ customerInfo.customerPhoneNumber }}
                  </div>
                </div>
                <div class="edit-name" v-if="phone">
                  <div class="text-block-75">Phone number</div>
                  <div class="flex-container">
                    <div class="child1">
                      <FormulateInput
                        type="select"
                        name="countryCode"
                        placeholder="Country code"
                        :options="codes"
                        v-model="updateCusModel.customerCountryCode"
                      />
                    </div>
                    <div class="child2">
                      <FormulateInput
                        type="text"
                        validation="number"
                        v-model="updateCusModel.customerPhoneNumber"
                        placeholder="Phone number"
                      />
                    </div>
                  </div>

                  <BaseComponentLoader
                    v-if="
                      loader.nonBlockingLoader &&
                        !about &&
                        !interest &&
                        !country &&
                        !timezone &&
                        !name
                    "
                    loaderAlignment="center"
                  />
                  <div v-else class="button-18 w-button" @click="closePhone">
                    Update
                  </div>
                </div>
              </div>

              <!--              <div class="profile-cover-photo">-->
              <!--                <div class="title-wrapper">-->
              <!--                  <div class="text-block-73">Profile Cover Photo</div>-->
              <!--                  <div class="div-block-97">-->
              <!--                    <div>-->
              <!--                      <a-->
              <!--                        href="#"-->
              <!--                        class="cancel-btn"-->
              <!--                        @click="togglePicture"-->
              <!--                        v-if="picture"-->
              <!--                        >Cancel</a-->
              <!--                      >-->
              <!--                    </div>-->
              <!--                    <div>-->
              <!--                      <a-->
              <!--                        href="#"-->
              <!--                        data-w-id="54163732-d9a1-6bc4-d958-d9aa1eba6ddf"-->
              <!--                        class="update-btn"-->
              <!--                        @click="togglePicture"-->
              <!--                        v-if="!picture"-->
              <!--                        >Change cover photo</a-->
              <!--                      >-->
              <!--                    </div>-->
              <!--                  </div>-->
              <!--                </div>-->
              <!--                <div class="saved-name-wrapper-copy">-->
              <!--                  <div class="text-block-74">-->
              <!--                    *You can upload images up to 1MB with a minimum dimension of-->
              <!--                    1440x180-->
              <!--                  </div>-->
              <!--                </div>-->
              <!--                <div class="div-block-98"></div>-->
              <!--              </div>-->
            </div>
          </div>
          <div
            data-w-tab="Tab 4"
            :class="professional ? 'w-tab-pane w--tab-active' : 'w-tab-pane'"
          >
            <div class="personal-info">
              <!--              <div class="payment-info-wrapper">-->
              <!--                <div class="profile-picture-wrapper">-->
              <!--                  <div class="div-block-96"><img loading="lazy" src="@/assets/timeslot-images/Profile-pics.svg" alt="">-->
              <!--                    <a href="#" class="link-block-8 w-inline-block"></a>-->
              <!--                  </div>-->
              <!--                  <div>-->
              <!--                    <div>-->
              <!--                      <a href="#" class="link-15">Upload profile picture</a>-->
              <!--                    </div>-->
              <!--                  </div>-->
              <!--                </div>-->
              <!--              </div>-->
              <div class="first-name-wrapper">
                <div class="title-wrapper">
                  <div class="text-block-73">
                    Unique Link
                    <div class="tooltip-mine">
                      <img
                        width="14"
                        height="14"
                        src="@/assets/timeslot-images/info.svg"
                      />
                      <span class="tooltiptext-mine"
                        >Personalize and share your unique link across all
                        social media platforms.</span
                      >
                    </div>
                  </div>
                  <div class="div-block-97">
                    <div>
                      <div
                        data-w-id="f8439559-0469-b343-0ce1-6b417602d5c1"
                        class="cancel-btn"
                        @click="toggleUniqueLink"
                        v-if="uniqueLink"
                      >
                        Cancel
                      </div>
                    </div>
                    <div>
                      <div
                        data-w-id="f8439559-0469-b343-0ce1-6b417602d5c4"
                        class="edit-btn"
                        @click="toggleUniqueLink"
                        v-if="!uniqueLink"
                      >
                        Update
                      </div>
                    </div>
                  </div>
                </div>
                <div class="saved-name-wrapper" v-if="!uniqueLink">
                  <div class="text-block-74">
                    {{ professionalInfo.professionalReference }}
                  </div>
                </div>

                <div class="edit-country" v-if="uniqueLink">
                  <div class="text-block-75">Enter new profile link</div>
                  <!--                  <select-->
                  <!--                    id="field-4"-->
                  <!--                    name="field-4"-->
                  <!--                    data-name="Field 4"-->
                  <!--                    class="select-field-3 w-select"-->
                  <!--                  >-->
                  <!--                    <option value="">Select category</option>-->
                  <!--                    <option value="First">First choice</option>-->
                  <!--                    <option value="Second">Second choice</option>-->
                  <!--                    <option value="Third">Third choice</option>-->
                  <!--                  </select>-->

                  <div class="booking-fee-holder">
                    <FormulateInput
                      type="text"
                      name="Professional Link"
                      :value="professionalInfo.professionalReference"
                      input-class="select-field"
                      v-model="updateModel.professionalReference"
                    />
                  </div>
                  <BaseComponentLoader
                    v-if="loader.nonBlockingLoader && !expertise"
                    loaderAlignment="left"
                  />

                  <div
                    v-else
                    class="button-18 w-button"
                    @click="closeUniqueLink"
                  >
                    Update
                  </div>
                </div>
                <!--                  <div class="text-block-75">Select expertise</div>-->
                <!--                  <input type="text" class="text-field settings w-input" maxlength="256" name="field-5" data-name="Field 5" placeholder="Enter name" id="field-5" required="">-->
                <!--                  <a data-w-id="f8439559-0469-b343-0ce1-6b417602d5cd" href="#" class="button-18 w-button" @click="closeName">Update</a>-->
              </div>
              <div class="first-name-wrapper">
                <div class="title-wrapper">
                  <div class="text-block-73">Category</div>
                  <div class="div-block-97">
                    <div>
                      <div
                        data-w-id="f8439559-0469-b343-0ce1-6b417602d5c1"
                        class="cancel-btn"
                        @click="toggleExpertise"
                        v-if="expertise"
                      >
                        Cancel
                      </div>
                    </div>
                    <div>
                      <div
                        data-w-id="f8439559-0469-b343-0ce1-6b417602d5c4"
                        class="edit-btn"
                        @click="toggleExpertise"
                        v-if="!expertise"
                      >
                        Update
                      </div>
                    </div>
                  </div>
                </div>
                <div class="saved-name-wrapper" v-if="!expertise">
                  <div class="text-block-74">
                    {{ professionalInfo.professionalCategory }}
                  </div>
                </div>

                <div class="edit-country" v-if="expertise">
                  <div class="text-block-75">Select category</div>
                  <div class="booking-fee-holder">
                    <FormulateInput
                      type="select"
                      name="Professional Category"
                      placeholder="e.g Technology"
                      :options="categoryList"
                      input-class="select-field"
                      v-model="updateModel.professionalCategory"
                    />
                  </div>
                  <BaseComponentLoader
                    v-if="loader.nonBlockingLoader"
                    loaderAlignment="left"
                  />

                  <div
                    v-else
                    class="button-18 w-button"
                    @click="closeExpertise"
                  >
                    Update
                  </div>
                </div>
                <!--                  <div class="text-block-75">Select expertise</div>-->
                <!--                  <input type="text" class="text-field settings w-input" maxlength="256" name="field-5" data-name="Field 5" placeholder="Enter name" id="field-5" required="">-->
                <!--                  <a data-w-id="f8439559-0469-b343-0ce1-6b417602d5cd" href="#" class="button-18 w-button" @click="closeName">Update</a>-->
              </div>
              <div class="first-name-wrapper">
                <div class="title-wrapper">
                  <div class="text-block-73">Role</div>
                  <div class="div-block-97">
                    <div>
                      <div
                        data-w-id="f8439559-0469-b343-0ce1-6b417602d5c1"
                        class="cancel-btn"
                        @click="toggleJob"
                        v-if="job"
                      >
                        Cancel
                      </div>
                    </div>
                    <div>
                      <div
                        data-w-id="f8439559-0469-b343-0ce1-6b417602d5c4"
                        class="edit-btn"
                        @click="toggleJob"
                        v-if="!job"
                      >
                        Edit
                      </div>
                    </div>
                  </div>
                </div>
                <div class="saved-name-wrapper" v-if="!job">
                  <div class="text-block-74">
                    {{ professionalInfo.professionalSubCategory }}
                  </div>
                </div>
                <div class="edit-name" v-if="job">
                  <div class="text-block-75">Role</div>
                  <div class="booking-fee-holder">
                    <FormulateInput
                      type="select"
                      name="professionalSubCategory"
                      placeholder="e.g Software Engineer"
                      :options="
                        categories[professionalInfo.professionalCategory]
                      "
                      input-class="select-field"
                      v-model="updateModel.professionalSubCategory"
                    />
                  </div>
                  <BaseComponentLoader
                    v-if="loader.nonBlockingLoader"
                    loaderAlignment="left"
                  />
                  <div
                    v-else
                    data-w-id="f8439559-0469-b343-0ce1-6b417602d5cd"
                    class="button-18 w-button"
                    @click="closeJob"
                  >
                    Update
                  </div>
                </div>
              </div>
              <div class="first-name-wrapper">
                <div class="title-wrapper">
                  <div class="text-block-73">Experience level</div>
                  <div class="div-block-97">
                    <div>
                      <div
                        data-w-id="f8439559-0469-b343-0ce1-6b417602d5c1"
                        class="cancel-btn"
                        @click="toggleExperience"
                        v-if="experience"
                      >
                        Cancel
                      </div>
                    </div>
                    <div>
                      <div
                        data-w-id="f8439559-0469-b343-0ce1-6b417602d5c4"
                        class="edit-btn"
                        @click="toggleExperience"
                        v-if="!experience"
                      >
                        Update
                      </div>
                    </div>
                  </div>
                </div>
                <div class="saved-name-wrapper" v-if="!experience">
                  <div class="text-block-74">
                    {{ professionalInfo.professionalExperienceLevel }}
                  </div>
                </div>

                <div class="edit-country" v-if="experience">
                  <div class="text-block-75">Select experience level</div>
                  <div class="booking-fee-holder">
                    <FormulateInput
                      type="select"
                      validation="required"
                      name="professionalExperienceLevel"
                      placeholder="e.g Beginner"
                      :options="experienceLevels"
                      input-class="select-field"
                      v-model="updateModel.professionalExperienceLevel"
                    />
                  </div>

                  <BaseComponentLoader
                    v-if="loader.nonBlockingLoader"
                    loaderAlignment="left"
                  />
                  <div
                    v-else
                    class="button-18 w-button"
                    @click="closeExperience"
                  >
                    Update
                  </div>
                </div>
                <!--                  <div class="text-block-75">Select expertise</div>-->
                <!--                  <input type="text" class="text-field settings w-input" maxlength="256" name="field-5" data-name="Field 5" placeholder="Enter name" id="field-5" required="">-->
                <!--                  <a data-w-id="f8439559-0469-b343-0ce1-6b417602d5cd" href="#" class="button-18 w-button" @click="closeName">Update</a>-->
              </div>
              <div class="first-name-wrapper">
                <div class="title-wrapper">
                  <div class="text-block-73">LinkedIn</div>
                  <div class="div-block-97">
                    <div>
                      <div
                        data-w-id="f8439559-0469-b343-0ce1-6b417602d5c1"
                        class="cancel-btn"
                        @click="toggleLinkedin"
                        v-if="linkedin"
                      >
                        Cancel
                      </div>
                    </div>
                    <div>
                      <div
                        data-w-id="f8439559-0469-b343-0ce1-6b417602d5c4"
                        class="edit-btn"
                        @click="toggleLinkedin"
                        v-if="!linkedin"
                      >
                        Edit
                      </div>
                    </div>
                  </div>
                </div>
                <div class="saved-name-wrapper" v-if="!linkedin">
                  <div class="text-block-74">
                    {{ professionalInfo.professionalLinkedinLink }}
                  </div>
                </div>
                <div class="edit-name" v-if="linkedin">
                  <div class="text-block-75">LinkedIn</div>
                  <div class="booking-fee-holder">
                    <FormulateInput
                      type="url"
                      name="sample"
                      placeholder="https://"
                      validation="required"
                      v-model="updateModel.professionalLinkedinLink"
                    />
                  </div>
                  <BaseComponentLoader
                    v-if="loader.nonBlockingLoader"
                    loaderAlignment="left"
                  />
                  <div
                    v-else
                    data-w-id="f8439559-0469-b343-0ce1-6b417602d5cd"
                    class="button-18 w-button"
                    @click="closeLinkedin"
                  >
                    Update
                  </div>
                </div>
              </div>
              <div class="interest-wrapper">
                <div class="title-wrapper">
                  <div class="text-block-73">
                    Booking Fee
                    <div class="tooltip-mine">
                      <img
                        width="14"
                        height="14"
                        src="@/assets/timeslot-images/info.svg"
                      />
                      <span class="tooltiptext-mine"
                        >Amount you want to charge for a session. Timeslate will
                        charge 20% on every consultation.</span
                      >
                    </div>
                  </div>
                  <div class="div-block-97">
                    <div>
                      <div
                        class="cancel-btn"
                        @click="toggleInterest"
                        v-if="interest"
                      >
                        Cancel
                      </div>
                    </div>
                    <div>
                      <div
                        data-w-id="9a67be6f-4ac0-883d-25ee-67df94af44b9"
                        class="update-btn"
                        @click="toggleInterest"
                        v-if="!interest"
                      >
                        Update
                      </div>
                    </div>
                  </div>
                </div>
                <div class="saved-name-wrapper" v-if="!interest">
                  <div class="text-block-74">
                    ${{ professionalInfo.professionalBookingFee }}
                  </div>
                </div>
                <div class="interest-select" v-if="interest">
                  <div class="text-block-75">Enter booking fee</div>
                  <div class="booking-fee-holder">
                    <FormulateInput
                      type="number"
                      placeholder="$0.00"
                      v-model="updateModel.professionalBookingFee"
                    />
                  </div>
                  <BaseComponentLoader
                    v-if="loader.nonBlockingLoader"
                    loaderAlignment="left"
                  />

                  <div v-else class="button-18 w-button" @click="closeInterest">
                    Update
                  </div>
                </div>
              </div>
              <div class="first-name-wrapper">
                <div class="title-wrapper">
                  <div class="text-block-73">
                    Weekly Subscription Amount
                    <div class="tooltip-mine">
                      <img
                        width="14"
                        height="14"
                        src="@/assets/timeslot-images/info.svg"
                      />
                      <span class="tooltiptext-mine"
                        >Amount you want to charge for a weekly subscription.
                        Timeslate will charge 20% on every consultation.</span
                      >
                    </div>
                  </div>
                  <div class="div-block-97">
                    <div>
                      <div
                        data-w-id="f8439559-0469-b343-0ce1-6b417602d5c1"
                        class="cancel-btn"
                        @click="toggleCompany"
                        v-if="company"
                      >
                        Cancel
                      </div>
                    </div>
                    <div>
                      <div
                        data-w-id="f8439559-0469-b343-0ce1-6b417602d5c4"
                        class="edit-btn"
                        @click="toggleCompany"
                        v-if="!company"
                      >
                        Edit
                      </div>
                    </div>
                  </div>
                </div>
                <div class="saved-name-wrapper" v-if="!company">
                  <div class="text-block-74">
                    ${{ profSubscriptions.weeklySubscriptionAmount }}
                  </div>
                </div>
                <div class="edit-name" v-if="company">
                  <div class="text-block-75">Weekly Subscription Amount</div>
                  <div class="booking-fee-holder">
                    <FormulateInput
                      type="number"
                      placeholder="$0.00"
                      v-model="updateSubModel.weeklySubscriptionAmount"
                    />
                  </div>
                  <BaseComponentLoader
                    v-if="loader.nonBlockingLoader"
                    loaderAlignment="left"
                  />
                  <div
                    v-else
                    data-w-id="f8439559-0469-b343-0ce1-6b417602d5cd"
                    class="button-18 w-button"
                    @click="closeCompany"
                  >
                    Update
                  </div>
                </div>
              </div>
              <div class="first-name-wrapper">
                <div class="title-wrapper">
                  <div class="text-block-73">
                    Monthly Subscription Amount
                    <div class="tooltip-mine">
                      <img
                        width="14"
                        height="14"
                        src="@/assets/timeslot-images/info.svg"
                      />
                      <span class="tooltiptext-mine"
                        >Amount you want to charge for a monthly subscription.
                        Timeslate will charge 20% on every consultation.</span
                      >
                    </div>
                  </div>
                  <div class="div-block-97">
                    <div>
                      <div
                        data-w-id="f8439559-0469-b343-0ce1-6b417602d5c1"
                        class="cancel-btn"
                        @click="togglePortfolio"
                        v-if="portfolio"
                      >
                        Cancel
                      </div>
                    </div>
                    <div>
                      <div
                        data-w-id="f8439559-0469-b343-0ce1-6b417602d5c4"
                        class="edit-btn"
                        @click="togglePortfolio"
                        v-if="!portfolio"
                      >
                        Edit
                      </div>
                    </div>
                  </div>
                </div>
                <div class="saved-name-wrapper" v-if="!portfolio">
                  <div class="text-block-74">
                    ${{ profSubscriptions.monthlySubscriptionAmount }}
                  </div>
                </div>
                <div class="edit-name" v-if="portfolio">
                  <div class="text-block-75">Monthly Subscription Amount</div>
                  <div class="booking-fee-holder">
                    <FormulateInput
                      type="number"
                      placeholder="$0.00"
                      v-model="updateSubModel.monthlySubscriptionAmount"
                    />
                  </div>
                  <BaseComponentLoader
                    v-if="loader.nonBlockingLoader"
                    loaderAlignment="left"
                  />
                  <div
                    v-else
                    data-w-id="f8439559-0469-b343-0ce1-6b417602d5cd"
                    class="button-18 w-button"
                    @click="closePortfolio"
                  >
                    Update
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            data-w-tab="Tab 2"
            :class="payment ? 'w-tab-pane w--tab-active' : 'w-tab-pane'"
          >
            <div class="personal-info">
              <div class="payment-info-wrapper"></div>
              <div class="country-wrapper">
                <div class="title-wrapper">
                  <div class="text-block-73">Country</div>
                  <div class="div-block-97">
                    <div>
                      <div
                        class="cancel-btn"
                        v-if="stripeCountry"
                        @click="toggleStripeCountry"
                      >
                        Cancel
                      </div>
                    </div>
                    <div>
                      <div
                        class="edit-btn"
                        v-if="!stripeCountry"
                        @click="toggleStripeCountry"
                      >
                        Edit
                      </div>
                    </div>
                  </div>
                </div>
                <div class="saved-country" v-if="!stripeCountry">
                  <div class="text-block-74">
                    <!--                    {{ customerInfo.payOutAccountBank }}-->
                    Country
                  </div>
                </div>
                <div class="edit-country" v-if="stripeCountry">
                  <div class="text-block-75">Select country</div>
                  <div class="child1">
                    <FormulateInput
                      type="select"
                      validation="required"
                      name="country"
                      validation-name="Country"
                      placeholder="Country"
                      :options="payOutCountries"
                      v-model="createStripeAccountModel.countryCode"
                      @change="createStripePayoutAccount"
                    />
                  </div>
                  <BaseComponentLoader
                    v-if="loader.nonBlockingLoader"
                    loaderAlignment="left"
                  />
                  <div
                    v-else
                    class="button-18 w-button"
                    @click="closeStripeCountry"
                  >
                    Update
                  </div>
                </div>
              </div>
              <div
                class="phone-number-wrapper"
                v-if="
                  isNigeria ||
                    customerInfo.payOutAccountCountry === 'NG' ||
                    customerInfo.payOutAccountCountry === 'Nigeria'
                "
              >
                <div class="title-wrapper">
                  <div class="text-block-73">Account details</div>
                  <div class="div-block-97">
                    <div>
                      <div class="cancel-btn" @click="toggleBank" v-if="bank">
                        Cancel
                      </div>
                    </div>
                    <div>
                      <div
                        data-w-id="58429a83-496c-7aa6-635b-a566e162047f"
                        class="edit-btn"
                        @click="toggleBank"
                        v-if="!bank"
                      >
                        Edit
                      </div>
                    </div>
                  </div>
                </div>
                <div class="saved-name-wrapper" v-if="!bank">
                  <div
                    class="text-block-74"
                    v-if="
                      customerInfo.payOutAccountBank &&
                        customerInfo.payOutAccountNumber
                    "
                  >
                    {{ customerInfo.payOutAccountBank }}
                    <span
                      v-if="
                        'payOutAccountBank' in customerInfo &&
                          'payOutAccountNumber' in customerInfo
                      "
                      >-</span
                    >
                    {{ customerInfo.payOutAccountNumber }}
                  </div>
                  <div class="text-block-74" v-else>Account details</div>
                </div>
                <div class="edit-name" v-if="bank">
                  <!--                  <div class="text-block-75">Account details</div>-->
                  <div class="flex-container">
                    <div class="child1">
                      <FormulateInput
                        type="text"
                        validation-name="Account name"
                        :placeholder="accountName"
                        v-model="paymentModel.payOutAccountName"
                      />
                    </div>
                    <div class="child2">
                      <FormulateInput
                        type="text"
                        validation-name="Bank"
                        :placeholder="accountBank"
                        v-model="paymentModel.payOutAccountBank"
                      />
                    </div>
                  </div>
                  <div class="flex-container">
                    <div class="child1">
                      <FormulateInput
                        type="text"
                        validation-name="Account number"
                        :placeholder="accountNumber"
                        v-model="paymentModel.payOutAccountNumber"
                      />
                    </div>
                    <!--                    <div class="child2">-->
                    <!--                      <FormulateInput-->
                    <!--                        type="select"-->
                    <!--                        validation="required"-->
                    <!--                        name="country"-->
                    <!--                        validation-name="Country"-->
                    <!--                        placeholder="Country"-->
                    <!--                        :options="countriesStripe"-->
                    <!--                        v-model="paymentModel.payOutAccountCountry"-->
                    <!--                      />-->
                    <!--                    </div>-->
                    <div class="div-block-235">
                      <!--                    <label for="name-4" class="field-label-22">OTP</label>-->
                      <div class="div-block-162">
                        <input
                          type="text"
                          class="text-field-25 w-input"
                          maxlength="256"
                          name="name-3"
                          data-name="Name 3"
                          placeholder="OTP"
                          id="name-3"
                          v-model="otp"
                        />
                        <a href="#" class="button-28 w-button" v-if="otpLoader"
                          >Sending OTP</a
                        >
                        <a
                          href="#"
                          class="button-28 w-button"
                          @click="resendOtp"
                          v-else
                          >Request OTP</a
                        >
                      </div>
                    </div>
                  </div>
                  <div class="flex-container">
                    <div class="child1">
                      <FormulateInput
                        type="select"
                        validation="required"
                        name="country"
                        validation-name="Country"
                        placeholder="Country"
                        :options="payOutCountries"
                        v-model="paymentModel.payOutAccountCountry"
                      />
                    </div>
                  </div>
                  <!--                  <div class="div-block-235">-->
                  <!--&lt;!&ndash;                    <label for="name-4" class="field-label-22">OTP</label>&ndash;&gt;-->
                  <!--                    <div class="div-block-162">-->
                  <!--                      <input-->
                  <!--                        type="text"-->
                  <!--                        class="text-field-25 w-input"-->
                  <!--                        maxlength="256"-->
                  <!--                        name="name-3"-->
                  <!--                        data-name="Name 3"-->
                  <!--                        placeholder="OTP"-->
                  <!--                        id="name-3"-->
                  <!--                      />-->
                  <!--                      <a href="#" class="button-28 w-button">Request OTP</a>-->
                  <!--                    </div>-->
                  <!--                  </div>-->

                  <BaseComponentLoader
                    v-if="loader.nonBlockingLoader"
                    loaderAlignment="left"
                  />
                  <div v-else class="button-18 w-button" @click="closeBank">
                    Update
                  </div>
                </div>
              </div>
              <!--              <div class="country-wrapper">-->
              <!--                <div class="title-wrapper">-->
              <!--                  <div class="text-block-73">Bank code/Sort code</div>-->
              <!--                  <div class="div-block-97">-->
              <!--                    <div>-->
              <!--                      <div-->
              <!--                        class="cancel-btn"-->
              <!--                        v-if="bankCode"-->
              <!--                        @click="toggleBankCode"-->
              <!--                      >-->
              <!--                        Cancel-->
              <!--                      </div>-->
              <!--                    </div>-->
              <!--                    <div>-->
              <!--                      <div-->
              <!--                        class="edit-btn"-->
              <!--                        v-if="!bankCode"-->
              <!--                        @click="toggleBankCode"-->
              <!--                      >-->
              <!--                        Edit-->
              <!--                      </div>-->
              <!--                    </div>-->
              <!--                  </div>-->
              <!--                </div>-->
              <!--                <div class="saved-country" v-if="!bankCode">-->
              <!--                  <div class="text-block-74">-->
              <!--                    &lt;!&ndash;                    {{ customerInfo.payOutAccountBank }}&ndash;&gt;-->
              <!--                    Bank Code/Sort Code-->
              <!--                  </div>-->
              <!--                </div>-->
              <!--                <div class="edit-country" v-if="bankCode">-->
              <!--                  <div class="text-block-75">Enter bank code/sort code</div>-->
              <!--                  <input-->
              <!--                    id="field-5"-->
              <!--                    name="field-5"-->
              <!--                    maxlength="256"-->
              <!--                    type="text"-->
              <!--                    class="text-field settings w-input"-->
              <!--                    data-name="field"-->
              <!--                    placeholder="Enter bank code"-->
              <!--                  />-->
              <!--                  <BaseComponentLoader-->
              <!--                    v-if="loader.nonBlockingLoader"-->
              <!--                    loaderAlignment="left"-->
              <!--                  />-->
              <!--                  <div v-else class="button-18 w-button" @click="closeBankCode">-->
              <!--                    Update-->
              <!--                  </div>-->
              <!--                </div>-->
              <!--              </div>-->

              <!--              <div class="about-wrapper">-->
              <!--                <div class="title-wrapper">-->
              <!--                  <div class="text-block-73">Account Number</div>-->
              <!--                  <div class="div-block-97">-->
              <!--                    <div>-->
              <!--                      <div-->
              <!--                        class="cancel-btn"-->
              <!--                        @click="toggleNumber"-->
              <!--                        v-if="number"-->
              <!--                      >-->
              <!--                        Cancel-->
              <!--                      </div>-->
              <!--                    </div>-->
              <!--                    <div>-->
              <!--                      <div-->
              <!--                        class="edit-btn"-->
              <!--                        @click="toggleNumber"-->
              <!--                        v-if="!number"-->
              <!--                      >-->
              <!--                        Edit-->
              <!--                      </div>-->
              <!--                    </div>-->
              <!--                  </div>-->
              <!--                </div>-->
              <!--                <div class="saved-description" v-if="!number">-->
              <!--                  <div class="text-block-74">-->
              <!--                    {{ customerInfo.payOutAccountNumber }}-->
              <!--                  </div>-->
              <!--                </div>-->
              <!--                <div class="edit-description" v-if="number">-->
              <!--                  <div class="text-block-75">Account Number</div>-->
              <!--                  <input-->
              <!--                    id="field-5"-->
              <!--                    name="field-5"-->
              <!--                    maxlength="256"-->
              <!--                    type="text"-->
              <!--                    class="text-field settings w-input"-->
              <!--                    data-name="field"-->
              <!--                    placeholder="Account number"-->
              <!--                    v-model="paymentModel.payOutAccountNumber"-->
              <!--                  />-->
              <!--                  <BaseComponentLoader-->
              <!--                    v-if="loader.nonBlockingLoader"-->
              <!--                    loaderAlignment="left"-->
              <!--                  />-->
              <!--                  <div v-else class="button-18 w-button" @click="closeNumber">-->
              <!--                    Update-->
              <!--                  </div>-->
              <!--                </div>-->
              <!--              </div>-->
              <!--              <div class="country-wrapper">-->
              <!--                <div class="title-wrapper">-->
              <!--                  <div class="text-block-73">Bank</div>-->
              <!--                  <div class="div-block-97">-->
              <!--                    <div>-->
              <!--                      <div class="cancel-btn" v-if="bank" @click="toggleBank">-->
              <!--                        Cancel-->
              <!--                      </div>-->
              <!--                    </div>-->
              <!--                    <div>-->
              <!--                      <div class="edit-btn" v-if="!bank" @click="toggleBank">-->
              <!--                        Edit-->
              <!--                      </div>-->
              <!--                    </div>-->
              <!--                  </div>-->
              <!--                </div>-->
              <!--                <div class="saved-country" v-if="!bank">-->
              <!--                  <div class="text-block-74">-->
              <!--                    {{ customerInfo.payOutAccountBank }}-->
              <!--                  </div>-->
              <!--                </div>-->
              <!--                <div class="edit-country" v-if="bank">-->
              <!--                  <div class="text-block-75">Select bank</div>-->
              <!--                  <input-->
              <!--                    id="field-5"-->
              <!--                    name="field-5"-->
              <!--                    maxlength="256"-->
              <!--                    type="text"-->
              <!--                    class="text-field settings w-input"-->
              <!--                    data-name="field"-->
              <!--                    placeholder="Enter bank name"-->
              <!--                    v-model="paymentModel.payOutAccountBank"-->
              <!--                  />-->
              <!--                  <BaseComponentLoader-->
              <!--                    v-if="loader.nonBlockingLoader"-->
              <!--                    loaderAlignment="left"-->
              <!--                  />-->
              <!--                  <div v-else class="button-18 w-button" @click="closeBank">-->
              <!--                    Update-->
              <!--                  </div>-->
              <!--                </div>-->
              <!--              </div>-->
            </div>
            <!--            <div class="personal-info">-->
            <!--              <div class="payment-info-wrapper"></div>-->
            <!--              <div class="first-name-wrapper">-->
            <!--                <div class="title-wrapper">-->
            <!--                  <div class="text-block-73">Account details</div>-->
            <!--                  <div class="div-block-97">-->
            <!--                    <div>-->
            <!--                      <a href="#" data-w-id="fbfe7593-bd4a-55bb-435a-4dcc74cf2132" class="cancel-btn">Cancel</a>-->
            <!--                    </div>-->
            <!--                    <div>-->
            <!--                      <a href="#" class="edit-btn">Edit</a>-->
            <!--                    </div>-->
            <!--                  </div>-->
            <!--                </div>-->
            <!--                <div class="saved-name-wrapper">-->
            <!--                  <div class="text-block-74">Seun Orofin</div>-->
            <!--                </div>-->
            <!--                <div class="edit-name">-->
            <!--                  <div class="text-block-75">Full Name</div><input type="text" class="text-field settings w-input" maxlength="256" name="field-5" data-name="Field 5" placeholder="Enter name" id="field-5" required="">-->
            <!--                  <a data-w-id="fbfe7593-bd4a-55bb-435a-4dcc74cf213e" href="#" class="button-18 w-button">Update</a>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </div>-->
            <!--            <div class="personal-info">-->
            <!--              <div class="payment-info-wrapper"></div>-->
            <!--              <div class="first-name-wrapper">-->
            <!--                <div class="title-wrapper">-->
            <!--                  <div class="text-block-73">Account details</div>-->
            <!--                  <div class="div-block-97">-->
            <!--                    <div>-->
            <!--                      <a href="#" data-w-id="acc212c7-5a1f-a1e1-609c-421dbda10632" class="cancel-btn">Cancel</a>-->
            <!--                    </div>-->
            <!--                    <div>-->
            <!--                      <a href="#" class="edit-btn">Cancel</a>-->
            <!--                    </div>-->
            <!--                  </div>-->
            <!--                </div>-->
            <!--                <div class="saved-name-wrapper">-->
            <!--                  <div class="w-form">-->
            <!--                    <form id="email-form-4" name="email-form-4" data-name="Email Form 4" method="get">-->
            <!--                      <div class="div-block-233">-->
            <!--                        <div class="div-block-235"><label for="field-7" class="field-label-22">Bank</label><select id="field-4" name="field-4" data-name="Field 4" class="select-field-8 w-select">-->
            <!--                          <option value="">GTBANK</option>-->
            <!--                          <option value="First">First choice</option>-->
            <!--                          <option value="Second">Second choice</option>-->
            <!--                          <option value="Third">Third choice</option>-->
            <!--                        </select></div>-->
            <!--                        <div class="div-block-235"><label for="name-3" class="field-label-22">Account Number</label><input type="text" class="text-field-26 w-input" maxlength="256" name="name-3" data-name="Name 3" placeholder="0121925568" id="name-3"></div>-->
            <!--                      </div>-->
            <!--                      <div class="div-block-233">-->
            <!--                        <div class="div-block-235"><label for="name-4" class="field-label-22">Phone number</label>-->
            <!--                          <div class="div-block-162"><input type="text" class="text-field-26 w-input" maxlength="256" name="name-3" data-name="Name 3" placeholder="09121000000" id="name-3"></div>-->
            <!--                        </div>-->
            <!--                        <div class="div-block-235"><label for="name-4" class="field-label-22">OTP</label>-->
            <!--                          <div class="div-block-162"><input type="text" class="text-field-25 w-input" maxlength="256" name="name-3" data-name="Name 3" placeholder="" id="name-3">-->
            <!--                            <a href="#" class="button-28 w-button">Request OTP</a>-->
            <!--                          </div>-->
            <!--                        </div>-->
            <!--                      </div>-->
            <!--                      <div class="div-block-233"></div><input type="submit" value="Save " data-wait="Please wait..." class="button w-button">-->
            <!--                    </form>-->
            <!--                    <div class="w-form-done">-->
            <!--                      <div>Thank you! Your submission has been received!</div>-->
            <!--                    </div>-->
            <!--                    <div class="w-form-fail">-->
            <!--                      <div>Oops! Something went wrong while submitting the form.</div>-->
            <!--                    </div>-->
            <!--                  </div>-->
            <!--                </div>-->
            <!--                <div class="edit-name">-->
            <!--                  <div class="text-block-75">Full Name</div><input type="text" class="text-field settings w-input" maxlength="256" name="field-5" data-name="Field 5" placeholder="Enter name" id="field-5" required="">-->
            <!--                  <a data-w-id="acc212c7-5a1f-a1e1-609c-421dbda1063e" href="#" class="button-18 w-button">Update</a>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </div>-->
          </div>
          <div
            data-w-tab="Tab 3"
            :class="security ? 'w-tab-pane w--tab-active' : 'w-tab-pane'"
          >
            <div class="personal-info">
              <div class="payment-info-wrapper"></div>
              <div class="first-name-wrapper">
                <div class="title-wrapper">
                  <div class="text-block-73">Change Password</div>
                  <div class="div-block-97">
                    <div>
                      <div
                        data-w-id="fb93d499-70af-9abe-011c-46212aa3b215"
                        class="cancel-btn"
                        @click="togglePassword"
                        v-if="password"
                      >
                        Cancel
                      </div>
                    </div>
                    <div>
                      <div
                        data-w-id="fb93d499-70af-9abe-011c-46212aa3b218"
                        class="edit-btn"
                        @click="togglePassword"
                        v-if="!password"
                      >
                        Edit
                      </div>
                    </div>
                  </div>
                </div>
                <div class="saved-name-wrapper" v-if="!password">
                  <div class="text-block-74">******</div>
                </div>
                <div class="edit-name" v-if="password">
                  <div class="text-block-75" style="margin-bottom:0;">
                    Current Password
                  </div>
                  <FormulateForm>
                    <img
                      v-if="type === 'password'"
                      @click="toggleOldPassword"
                      style="cursor: pointer;"
                      src="@/assets/timeslot-images/visual.png"
                      class="password-eye"
                    />
                    <img
                      @click="toggleOldPassword"
                      style="cursor: pointer;"
                      v-else
                      src="@/assets/timeslot-images/eye.png"
                      class="password-eye"
                    />
                    <FormulateInput
                      :type="type"
                      name="oldPassword"
                      placeholder="Enter your current password"
                      v-model="passwordModel.oldPassword"
                    />
                    <div class="text-block-75" style="margin-bottom:0;">
                      New Password
                    </div>
                    <img
                      v-if="typeNew === 'password'"
                      src="@/assets/timeslot-images/visual.png"
                      class="password-eye"
                      @click="toggleNewPassword"
                      style="cursor: pointer;"
                    />
                    <img
                      v-else
                      src="@/assets/timeslot-images/eye.png"
                      class="password-eye"
                      @click="toggleNewPassword"
                      style="cursor: pointer;"
                    />
                    <FormulateInput
                      :type="typeNew"
                      name="password"
                      placeholder="Enter your new password"
                      validation="bail|required"
                      validation-name="New password"
                      v-model="passwordModel.password"
                      error-behavior="value"
                      :validation-messages="{
                        matches: 'Password must be 4-6 digits only'
                      }"
                    />
                    <div class="text-block-75" style="margin-bottom:0;">
                      Confirm New Password
                    </div>
                    <img
                      v-if="typeConfirm === 'password'"
                      src="@/assets/timeslot-images/visual.png"
                      class="password-eye"
                      @click="toggleConfirmPassword"
                      style="cursor: pointer;"
                    />
                    <img
                      v-else
                      src="@/assets/timeslot-images/eye.png"
                      class="password-eye"
                      @click="toggleConfirmPassword"
                      style="cursor: pointer;"
                    />
                    <FormulateInput
                      :type="typeConfirm"
                      name="password_confirm"
                      validation="required|confirm"
                      placeholder="Confirm your new password"
                      validation-name="Password confirmation"
                      v-model="passwordModel.passwordConfirmation"
                    />
                  </FormulateForm>

                  <BaseComponentLoader
                    v-if="loader.nonBlockingLoader"
                    loaderAlignment="left"
                  />
                  <div v-else class="button-18 w-button" @click="closePassword">
                    Update
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SuccessMessageModal
      v-if="changePasswordSuccess"
      :button-action="closeModal"
      :message="'You have changed your password successfully'"
      :cancel="closeModal"
    />
    <!--    <template v-slot:right-side-nav>-->
    <!--      <div></div>-->
    <!--    </template>-->
  </TimeslotDashboardLayout>
</template>

<script>
import TimeslotDashboardLayout from "@/views/timeslot/TimeslotDashboardLayout";
// import ProfessionalAppNavBar from "@/components/navbar/ProfessionalAppNavBar";
// import ProfessionalSidebar from "@/views/timeslot/ProfessionalSidebar";
import { mapState } from "vuex";
import CustomerRequest from "@/model/requests/CustomerRequest";
import ProfessionalRequest from "@/model/requests/ProfessionalRequest";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import { countryCodes } from "@/utils/country/countryCodes";
import { stripeCountries } from "@/utils/country/stripeCountries";
import BaseComponentLoader from "@/components/BaseComponents/BaseComponentLoader";
import SubscriptionRequest from "@/model/requests/SubscriptionRequest";
import PayOutAccountRequest from "@/model/requests/PayOutAccountRequest";
import AuthRequest from "@/model/requests/AuthRequest";
import SuccessMessageModal from "@/components/modal/SuccessMessageModal";
import RouterUtils from "@/utils/BaseUtils/RouterUtils";
export default {
  name: "ProfessionalSettings",
  components: {
    TimeslotDashboardLayout,
    // ProfessionalAppNavBar,
    // ProfessionalSidebar,
    BaseComponentLoader,
    SuccessMessageModal
  },
  data() {
    return {
      bar: true,
      cross: false,
      personal: true,
      payment: false,
      security: false,
      name: false,
      about: false,
      country: false,
      timezone: false,
      phone: false,
      interest: false,
      picture: false,
      account: false,
      number: false,
      bank: false,
      country2: false,
      payment2: false,
      withdraw: false,
      password: false,
      professional: false,
      expertise: false,
      uniqueLink: false,
      experience: false,
      company: false,
      job: false,
      portfolio: false,
      linkedin: false,
      bankCode: false,
      stripeCountry: false,
      updateModel: ProfessionalRequest.update,
      professionalCategory: "Aviation",
      readModel: ProfessionalRequest.readBy,
      subModel: SubscriptionRequest.update,
      paymentModel: PayOutAccountRequest.update,
      imageModel: CustomerRequest.uploadImage,
      passwordModel: AuthRequest.changePassword,
      updateCusModel: CustomerRequest.update,
      readSubModel: ProfessionalRequest.readSubscriptionPlans,
      updateSubModel: ProfessionalRequest.updateSubscriptionPlans,
      customerModel: CustomerRequest.readBy,
      type: "password",
      typeConfirm: "password",
      typeNew: "password",
      createStripeAccountModel: PayOutAccountRequest.createStripePayoutAccount,
      resendModel: AuthRequest.resendOtp,
      otp: "",
      otpLoader: false,
      isNigeria: false,
      pictureLoad: false,
      showMaxWordCountError: false
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.auth.userInfo,
      professionalInfo: state => state.professional.professionalInfo,
      imageUrl: state => state.customer.imageUrl,
      changePasswordSuccess: state => state.auth.changePasswordSuccess,
      customerInfo: state => state.customer.customerInfo,
      profSubscriptions: state => state.professional.profSubscriptions,
      professionalId: state => state.professional.professionalId,
      customerToProfessionalId: state =>
        state.professional.customerToProfessionalId,
      otpLoading: state => state.auth.otpLoading
    }),
    ...mapState(["loader"]),
    countries() {
      return countryCodes.map(data => {
        return { label: data.name, value: data.name };
      });
    },
    payOutCountries() {
      return countryCodes.map(data => {
        return { label: data.name, value: data.code, id: data.id };
      });
    },
    // profRef() {
    //   return `https://www.timeslate.com/${this.professionalInfo.professionalReference}`;
    // },
    codes() {
      // return countryCodes.map(data => `${data.name}: ${data.dial_code}`);
      return countryCodes.map(data => {
        return {
          label: `${data.name}:${data.dial_code}`,
          value: data.dial_code,
          id: data.code
        };
      });
    },
    timezones() {
      return StoreUtils.rootGetters("customer/getTimezones");
    },
    timezoneList() {
      return this.timezones.map(data => {
        return {
          label: `${data.timeZoneName}:${data.timeZoneOffset}(${data.timeZoneAbbreviation})`,
          value: data.timeZoneName,
          id: data.timeZoneId
        };
      });
    },
    categories() {
      return StoreUtils.rootGetters(
        StoreUtils.getters.professional.GET_CATEGORIES
      );
    },
    categoryList() {
      return Object.keys(this.categories);
    },
    experienceLevels() {
      return StoreUtils.rootGetters(
        StoreUtils.getters.professional.GET_EXPERIENCE_LEVELS
      );
    },
    accountName() {
      if (this.customerInfo.payOutAccountName) {
        return this.customerInfo.payOutAccountName;
      } else {
        return "Account name";
      }
    },
    accountBank() {
      if (this.customerInfo.payOutAccountBank) {
        return this.customerInfo.payOutAccountBank;
      } else {
        return "Bank";
      }
    },
    accountNumber() {
      if (this.customerInfo.payOutAccountNumber) {
        return this.customerInfo.payOutAccountNumber;
      } else {
        return "Account number";
      }
    }
    // accountCountry() {
    //   if (this.customerInfo.payOutAccountCountry) {
    //     return this.customerInfo.payOutAccountCountry;
    //   } else {
    //     return "Country";
    //   }
    //
    // }
  },
  methods: {
    getWordCount() {
      if (this.updateModel.professionalSummary !== null) {
        return this.updateModel.professionalSummary.length;
      } else {
        return 0;
      }
    },
    createStripePayoutAccount() {
      if (this.createStripeAccountModel.countryCode !== "NG")
        StoreUtils.dispatch(
          "payOutAccount/createStripePayoutAccount",
          this.createStripeAccountModel
        );
    },
    resendOtp() {
      this.resendModel.username = this.userInfo.customerEmail;
      this.resendModel.countryCode = "234";
      StoreUtils.dispatch(StoreUtils.actions.auth.RESEND_OTP, this.resendModel);
    },
    showNav() {
      this.cross = true;
      this.bar = false;
    },
    closeNav() {
      this.bar = true;
      this.cross = false;
    },
    goToProfile() {
      let professionalId;
      if ("professional" in this.userInfo) {
        professionalId = this.userInfo.professional.professionalId;
      } else {
        professionalId = this.customerToProfessionalId;
      }
      RouterUtils.changeRouteUrlTo(`/professionals/${professionalId}`);
    },
    logout() {
      StoreUtils.dispatch(StoreUtils.actions.auth.LOGOUT);
    },
    uploadProfile() {
      document.getElementById("upload-profile").click();
    },
    createURL(imageFile) {
      let reader = new FileReader();
      reader.onload = e =>
        (this.updateModel.customerDisplayPicture = e.target.result);
      reader.readAsDataURL(imageFile);
    },
    onImageSelect(e) {
      const files = e.target.files;

      if (files.length) {
        this.createURL(files[0]);
      }
    },
    uploadImageProfile() {
      this.imageModel.base64 = this.updateModel.customerDisplayPicture;
      this.imageModel.type = "profile";
      this.imageModel.customerId = this.userInfo.customerId;
      StoreUtils.dispatch("customer/uploadImage", this.imageModel).then(
        () => (this.pictureLoad = true)
      );
    },
    closeModal() {
      StoreUtils.commit("auth/SET_CHANGE_PASSWORD_SUCCESS", false);
    },
    openPersonal() {
      this.personal = true;
      this.payment = false;
      this.security = false;
      this.professional = false;
    },
    openProfessional() {
      this.personal = false;
      this.professional = true;
      this.payment = false;
      this.security = false;
    },
    openPayment() {
      this.professional = false;
      this.payment = true;
      this.personal = false;
      this.security = false;
    },
    openSecurity() {
      this.payment = false;
      this.security = true;
      this.personal = false;
      this.professional = false;
    },
    toggleName() {
      this.name = !this.name;
    },
    closeName() {
      // this.name = false;
      this.updateCusModel.customerId = this.userInfo.customerId;
      StoreUtils.dispatch("customer/updateCustomer", this.updateCusModel).then(
        () => {
          this.name = false;
        }
      );
    },
    toggleAbout() {
      this.about = !this.about;
    },
    toggleBankCode() {
      this.bankCode = !this.bankCode;
    },
    closeBankCode() {
      this.bankCode = false;
    },
    toggleStripeCountry() {
      this.stripeCountry = !this.stripeCountry;
    },
    closeStripeCountry() {
      this.stripeCountry = false;
    },
    closeAbout() {
      // this.updateModel.professionalId = this.professionalId;
      if ("professional" in this.userInfo) {
        this.updateModel.professionalId = this.userInfo.professional.professionalId;
      } else {
        this.updateModel.professionalId = this.customerToProfessionalId;
      }
      if (this.updateModel.professionalSummary.length <= 150) {
        StoreUtils.dispatch(
          "professional/updateProfessional",
          this.updateModel
        ).then(() => {
          this.about = false;
        });
      }
    },
    toggleCountry() {
      this.country = !this.country;
    },
    closeCountry() {
      // this.country = false;
      this.updateCusModel.customerId = this.userInfo.customerId;
      StoreUtils.dispatch("customer/updateCustomer", this.updateCusModel).then(
        () => {
          this.country = false;
        }
      );
    },
    toggleTimezone() {
      this.timezone = !this.timezone;
    },
    closeTimezone() {
      this.updateCusModel.customerId = this.userInfo.customerId;
      StoreUtils.dispatch("customer/updateCustomer", this.updateCusModel).then(
        () => {
          this.timezone = false;
        }
      );
    },
    togglePhone() {
      this.phone = !this.phone;
    },
    closePhone() {
      // this.phone = false;
      this.updateCusModel.customerId = this.userInfo.customerId;
      StoreUtils.dispatch("customer/updateCustomer", this.updateCusModel).then(
        () => {
          this.phone = false;
        }
      );
    },
    toggleInterest() {
      this.interest = !this.interest;
    },
    closeInterest() {
      // this.interest = false;
      // this.updateModel.professionalId = this.professionalId;
      if ("professional" in this.userInfo) {
        this.updateModel.professionalId = this.userInfo.professional.professionalId;
      } else {
        this.updateModel.professionalId = this.customerToProfessionalId;
      }
      StoreUtils.dispatch(
        "professional/updateProfessional",
        this.updateModel
      ).then(() => {
        this.interest = false;
      });
    },
    togglePicture() {
      this.picture = !this.picture;
    },
    closePicture() {
      this.picture = false;
    },
    toggleAccount() {
      this.account = !this.account;
    },
    closeAccount() {
      this.account = false;
    },
    toggleNumber() {
      this.number = !this.number;
    },
    closeNumber() {
      this.paymentModel.payOutAccountCustomerId = this.userInfo.customerId;
      StoreUtils.dispatch(
        "payOutAccount/updatePayOutAccount",
        this.paymentModel
      ).then(() => {
        this.number = false;
      });
    },
    toggleBank() {
      this.bank = !this.bank;
    },
    closeBank() {
      this.paymentModel.payOutAccountCustomerId = this.userInfo.customerId;
      this.paymentModel.otp = this.otp;
      StoreUtils.dispatch(
        "payOutAccount/updatePayOutAccount",
        this.paymentModel
      ).then(() => {
        this.bank = false;
        this.otp = "";
      });
      // this.bank = false;
    },
    toggleCountry2() {
      this.country2 = !this.country2;
    },
    closeCountry2() {
      this.country2 = false;
    },
    togglePayment2() {
      this.payment2 = !this.payment2;
    },
    closePayment2() {
      this.payment2 = false;
    },
    toggleWithdraw() {
      this.withdraw = !this.withdraw;
    },
    closeWithdraw() {
      this.withdraw = false;
    },
    togglePassword() {
      this.password = !this.password;
    },
    closePassword() {
      this.passwordModel.username = this.userInfo.customerEmail;
      this.passwordModel.countryCode = this.userInfo.customerCountryCode;
      StoreUtils.dispatch("auth/changePassword", this.passwordModel).then(
        () => {
          this.password = false;
        }
      );
      // this.password = false;
    },
    toggleExpertise() {
      this.expertise = !this.expertise;
    },
    closeExpertise() {
      if ("professional" in this.userInfo) {
        this.updateModel.professionalId = this.userInfo.professional.professionalId;
      } else {
        this.updateModel.professionalId = this.customerToProfessionalId;
      }
      StoreUtils.dispatch(
        "professional/updateProfessional",
        this.updateModel
      ).then(() => {
        this.expertise = false;
      });
    },
    toggleExperience() {
      this.experience = !this.experience;
    },
    closeExperience() {
      if ("professional" in this.userInfo) {
        this.updateModel.professionalId = this.userInfo.professional.professionalId;
      } else {
        this.updateModel.professionalId = this.customerToProfessionalId;
      }
      StoreUtils.dispatch(
        "professional/updateProfessional",
        this.updateModel
      ).then(() => {
        this.experience = false;
      });
    },
    toggleCompany() {
      this.company = !this.company;
    },
    closeCompany() {
      if ("professional" in this.userInfo) {
        this.updateSubModel.subscriptionPlanProfessionalId = this.userInfo.professional.professionalId;
      } else {
        this.updateSubModel.subscriptionPlanProfessionalId = this.customerToProfessionalId;
      }
      // this.updateSubModel.subscriptionPlanProfessionalId = this.professionalId;
      this.updateSubModel.monthlySubscriptionAmount = this.profSubscriptions.monthlySubscriptionAmount;
      StoreUtils.dispatch(
        "professional/updateSubscriptionPlans",
        this.updateSubModel
      ).then(() => {
        this.company = false;
      });
    },
    toggleJob() {
      this.job = !this.job;
    },
    closeJob() {
      if ("professional" in this.userInfo) {
        this.updateModel.professionalId = this.userInfo.professional.professionalId;
      } else {
        this.updateModel.professionalId = this.customerToProfessionalId;
      }
      StoreUtils.dispatch(
        "professional/updateProfessional",
        this.updateModel
      ).then(() => {
        this.job = false;
      });
    },
    togglePortfolio() {
      this.portfolio = !this.portfolio;
    },
    closePortfolio() {
      if ("professional" in this.userInfo) {
        this.updateSubModel.subscriptionPlanProfessionalId = this.userInfo.professional.professionalId;
      } else {
        this.updateSubModel.subscriptionPlanProfessionalId = this.customerToProfessionalId;
      }
      this.updateSubModel.weeklySubscriptionAmount = this.profSubscriptions.weeklySubscriptionAmount;
      StoreUtils.dispatch(
        "professional/updateSubscriptionPlans",
        this.updateSubModel
      ).then(() => {
        this.portfolio = false;
      });
    },
    toggleLinkedin() {
      this.linkedin = !this.linkedin;
    },
    closeLinkedin() {
      if ("professional" in this.userInfo) {
        this.updateModel.professionalId = this.userInfo.professional.professionalId;
      } else {
        this.updateModel.professionalId = this.customerToProfessionalId;
      }
      StoreUtils.dispatch(
        "professional/updateProfessional",
        this.updateModel
      ).then(() => {
        this.linkedin = false;
      });
    },
    toggleUniqueLink() {
      this.uniqueLink = !this.uniqueLink;
    },
    closeUniqueLink() {
      if ("professional" in this.userInfo) {
        this.updateModel.professionalId = this.userInfo.professional.professionalId;
      } else {
        this.updateModel.professionalId = this.customerToProfessionalId;
      }
      StoreUtils.dispatch(
        "professional/updateProfessional",
        this.updateModel
      ).then(() => {
        this.uniqueLink = false;
      });
    },
    toggleOldPassword() {
      if (this.type === "password") {
        this.type = "text";
        this.image = "eye";
      } else {
        this.type = "password";
        this.image = "visual";
      }
    },
    toggleNewPassword() {
      if (this.typeNew === "password") {
        this.typeNew = "text";
        this.image = "eye";
      } else {
        this.typeNew = "password";
        this.image = "visual";
      }
    },
    toggleConfirmPassword() {
      if (this.typeConfirm === "password") {
        this.typeConfirm = "text";
        this.image = "eye";
      } else {
        this.typeConfirm = "password";
        this.image = "visual";
      }
    }
  },
  watch: {
    otpLoading(newValue) {
      if (newValue === true) {
        return (this.otpLoader = true);
      } else {
        return (this.otpLoader = false);
      }
    },
    "createStripeAccountModel.countryCode"(newValue) {
      if (newValue === "NG") {
        this.isNigeria = true;
      } else {
        this.isNigeria = false;
      }
    },
    "updateModel.professionalSummary"(newValue) {
      if (newValue.length > 150) {
        this.showMaxWordCountError = true;
      } else {
        this.showMaxWordCountError = false;
      }
    }
  },
  mounted() {
    StoreUtils.dispatch(StoreUtils.actions.professional.FETCH_CATEGORIES);
    StoreUtils.dispatch(
      StoreUtils.actions.professional.FETCH_EXPERIENCE_LEVELS
    );
    StoreUtils.dispatch("customer/readTimezones");

    if ("professional" in this.userInfo) {
      this.readSubModel.subscriptionPlanProfessionalId = this.userInfo.professional.professionalId;
    } else {
      this.readSubModel.subscriptionPlanProfessionalId = this.customerToProfessionalId;
    }
    StoreUtils.dispatch(
      "professional/readSubscriptionPlans",
      this.readSubModel
    );
    if ("professional" in this.userInfo) {
      this.readModel.professionalId = this.userInfo.professional.professionalId;
    } else {
      this.readModel.professionalId = this.customerToProfessionalId;
    }
    StoreUtils.dispatch("professional/readByProfessionalId", this.readModel);
    this.customerModel.customerId = this.userInfo.customerId;
    StoreUtils.dispatch("customer/readByCustomerId", this.customerModel);
  }
};
</script>

<style scoped>
.icon {
  padding: 10px;
  min-width: 40px;
}
.password-eye {
  position: relative;
  top: 38px;
  left: 90%;
  width: 20px;
  height: 20px;
  opacity: 0.7;
}
.booking-fee-holder {
  width: 50%;
}
.booking-fee-holder-2 {
  width: 80%;
}
.profile-picture-timeslot {
  height: 116px;
  width: 116px;
  border-radius: 10px;
  /*object-fit:cover;*/
  max-width: 100%;
  cursor: pointer;
}
.flex-container {
  display: flex;
  /*justify-content: space-between;*/
  gap: 10px;
}
.child1 {
  width: 50%;
}
.child2 {
  width: 50%;
}
input[type="file"] {
  height: 23px;
  width: 23px;
  border-radius: 50%;
  position: absolute;
  opacity: 0;
  cursor: pointer;
}
.tooltip-mine {
  position: relative;
  display: inline-block;
  cursor: pointer;
  /*border-bottom: 1px dotted black;*/
}

.tooltip-mine .tooltiptext-mine {
  visibility: hidden;
  width: 250px;
  /*background-color: #256ff6;*/
  /*color: #fff;*/
  text-align: left;
  border-radius: 6px;
  padding: 10px;
  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  /*background-color: rgba(37, 111, 246, 0.9);*/
  /*color: #256ff6;*/
  font-size: 12px;
  background-color: rgba(37, 111, 246, 0.1);
  color: #256ff6;
  top: 100%;
  left: 50%;
  margin-left: -60px;
}

.tooltip-mine:hover .tooltiptext-mine {
  visibility: visible;
}

@media only screen and (max-width: 600px) {
  .text-field-25 {
    height: 50px;
    width: 100%;
  }
  .button-28 {
    width: 100%;
    height: 50px;
  }
}
</style>
